module.exports = __webpack_public_path__ + "static/media/PassportMobileIPad.b1922252.png";